import Layout from '@/layout'

// 发行中心路由

export const ly = [
  {
    path: '/ly/market',
    component: Layout,
    redirect: '/ly/market/overview',
    name: 'LYMarket',
    alwaysShow: true,
    meta: {
      title: '发行数据分析',
      icon: 'el-icon-data-analysis',
      elementuiIcon: true,
      permission_uri: '/ly/market'
    },
    children: [{
      path: 'overview',
      name: 'LYMarketOverview',
      component: () => import('@/views/ly/market/overview'),
      meta: {
        title: '发行总览',
        icon: 'overview',
        permission_uri: '/ly/market/overview'
      }
    }, {
      path: 'retain',
      name: 'LYMarketRetain',
      component: () => import('@/views/ly/market/retain'),
      meta: {
        title: '留存情况',
        icon: 'retain',
        permission_uri: '/ly/market/retain'
      }
    }, {
      path: 'payment',
      name: 'LYMarketPayment',
      component: () => import('@/views/ly/market/payment'),
      meta: {
        title: '付费情况',
        icon: 'payment',
        permission_uri: '/ly/market/payment'
      }
    }, {
      path: 'simple-hour-overview',
      name: 'LYMarketSimpleHourOverview',
      component: () => import('@/views/ly/market/simpleHourOverview'),
      meta: {
        title: '分时数据',
        icon: 'dashboard',
        permission_uri: '/ly/market/simple-hour-overview'
      }
    }, {
      path: 'wastage',
      name: 'LYMarketWastage',
      component: () => import('@/views/ly/market/wastage'),
      meta: {
        title: '流失情况',
        icon: 'log',
        permission_uri: '/ly/market/wastage'
      }
    }, {
      path: 'game-online',
      name: 'LYMarketGameOnline',
      component: () => import('@/views/ly/market/gameOnline'),
      meta: {
        title: '游戏在线情况',
        icon: 'kpi',
        permission_uri: '/ly/market/game-online'
      }
    }, {
      path: 'recharge-rank',
      name: 'LYRechargeRank',
      component: () => import('@/views/ly/market/rechargeRank'),
      meta: {
        title: '充值排行榜',
        icon: 'dashboard',
        permission_uri: '/ly/market/recharge-rank'
      }
    }, {
      path: 'front-end-conversion',
      name: 'LYFrontEndConversion',
      component: () => import('@/views/ly/market/frontEndConversion'),
      meta: {
        title: '前端转化',
        icon: 'comparison',
        permission_uri: '/ly/market/front-end-conversion'
      }
    }, {
      path: 'account-bind',
      name: 'LYAccountBind',
      component: () => import('@/views/ly/market/accountBind'),
      meta: {
        title: '账号绑定情况',
        icon: 'database',
        permission_uri: '/ly/market/account-bind'
      }
    }]
  },
  {
    path: '/ly/permission',
    component: Layout,
    redirect: '/ly/permission/member',
    name: 'LYPermission',
    alwaysShow: true,
    meta: {
      title: '权限管理',
      icon: 'permission',
      permission_uri: '/ly/permission'
    },
    children: [{
      path: 'member',
      name: 'LYPermissionMember',
      component: () => import('@/views/ly/permission/member'),
      meta: {
        title: '成员管理',
        icon: 'user',
        permission_uri: '/ly/permission/member'
      }
    }]
  },
  {
    path: '/ly/datahub',
    component: Layout,
    redirect: '/ly/datahub/cost-input',
    name: 'DataManage',
    alwaysShow: true,
    meta: {
      title: '数据管理',
      icon: 'database',
      permission_uri: '/ly/datahub'
    },
    children: [{
      path: 'cost-input',
      name: 'LYCostInput',
      component: () => import('@/views/ly/dataManage/costInput'),
      meta: {
        title: '消耗录入',
        icon: 'comparison',
        permission_uri: '/ly/datahub/cost-input'
      }
    },
    {
      path: 'enter-cost',
      name: 'EnterCost',
      component: () => import('@/views/ly/dataManage/operationProfitInput'),
      meta: {
        title: '成本录入',
        icon: 'comparison',
        permission_uri: '/ly/datahub/enter-cost'
      }
    },
    {
      path: 'channel-profit',
      name: 'ChannelProfit',
      component: () => import('@/views/ly/dataManage/channelProfit'),
      meta: {
        title: '运营利润',
        icon: 'dashboard',
        permission_uri: '/ly/datahub/channel-profit'
      }
    },
    {
      path: 'data-config',
      name: 'LYDataConfig',
      component: () => import('@/views/ly/dataManage/dataConfig'),
      meta: {
        title: '数据配置',
        icon: 'el-icon-setting',
        elementuiIcon: true,
        permission_uri: '/ly/datahub/data-config'
      }
    }, {
      path: 'data-query',
      name: 'LYDataQuery',
      component: () => import('@/views/ly/dataManage/dataQuery'),
      meta: {
        title: '数据查询',
        icon: 'el-icon-search',
        elementuiIcon: true,
        permission_uri: '/ly/datahub/data-query'
      }
    }]
  }
]
